<template>
  <vddl-list :list="list" :external-sources="false" :disable-if="true">
    <vddl-draggable
      v-for="(item, index) in list"
      :key="item.id"
      :dragstart="onDragStart"
      :type="type"
      :draggable="item"
      :index="index"
      :wrapper="list"
      :moved="onMoved"
      :canceled="onCancel"
      effect-allowed="move"
      class="h-5"
    >
      <Tooltip side="top" :side-offset="12" :delay-duration="400" :open="open">
        <IconButton
          type="button"
          class="bg-transparent cursor-grab w-auto h-auto"
        >
          <svg-icon
            :width="'22'"
            :height="'20'"
            icon="app-icons/new-element"
            :svg-fill="true"
          />
        </IconButton>
        <template #content>
          <p>Drag new element</p>
        </template>
      </Tooltip>
    </vddl-draggable>
  </vddl-list>
</template>

<script setup>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { IconButton } from '@ui/components/icon-button';
import { Tooltip } from '@ui/components/tooltip';
import SvgIcon from '@ui/components/SvgIcon.vue';

import { DRAG_TYPE } from '@/constants.js';

const store = useStore();
const open = ref(undefined);
const type = DRAG_TYPE.NEW_ELEMENT;
const list = ref([
  {
    id: 0,
  },
]);

const onDragStart = () => {
  open.value = false;
  store.dispatch('application/drag/setItems', {
    value: { type: DRAG_TYPE.NEW_ELEMENT, ids: [] },
  });
};

const onMoved = () => {
  store.dispatch('application/drag/clear');

  open.value = false;
};
const onCancel = () => {
  store.dispatch('application/drag/clear');

  open.value = false;
};
</script>
